import {NutrientType} from "../../models/nutrient";
import React from "react";
import {useTranslation} from "next-i18next";
import {Heading4, HeroHeading2, Paragraph} from "../text";
import {MacroPlanMacrosPieChart} from "./MacroPlanMacrosPieChart";
import Skeleton from "react-loading-skeleton";

export interface MacroPlanMacrosViewProps {
  nutrients: Map<NutrientType, number>
  isLoading: boolean
}

export const MacroPlanMacrosView: React.FC<MacroPlanMacrosViewProps> = ({ nutrients, isLoading }) => {
  const { t } = useTranslation()

  const calories = nutrients.get("CALORIES") ?? 0
  const protein = nutrients.get("PROTEIN") ?? 0
  const carbohydrate = nutrients.get("CARBOHYDRATE") ?? 0
  const fat = nutrients.get("FAT") ?? 0

  return <div className="flex space-x-6 items-center">
    <div className="flex flex-col flex-shrink-0 space-y-2 items-center">
      <HeroHeading2 className="text-center">{isLoading ? <Skeleton className="!w-16" /> : calories}</HeroHeading2>
      <Paragraph className="uppercase text-center text-fg-gray-dark">{isLoading ? <Skeleton className="!w-20" /> : t('common:nutrient_calories')}</Paragraph>
    </div>

    <div className="h-16 lg:h-20 w-0.5 rounded-full bg-fg-gray-surface flex-shrink-0" />

    <MacroPlanMacrosPieChart className="lg:col-span-4 h-20 w-20 lg:h-24 lg:w-24 flex-shrink-0" nutrients={nutrients} isLoading={isLoading} />

    <div className="flex flex-col flex-grow space-y-2">
      <div className="flex space-x-2 items-center w-full">
        {isLoading ? <Skeleton className="!w-4 !h-4 !rounded-full" /> : <div className="rounded-full bg-fg-purple-light h-4 w-4"/>}
        <Paragraph className="text-fg-gray-dark flex-grow uppercase">{isLoading ? <Skeleton className="!w-16" /> : t('common:nutrient_protein')}</Paragraph>
        <Heading4 className="text-left justify-self-end">{isLoading ? <Skeleton className="!w-10" /> : protein + t('common:nutrient_unit_gram')}</Heading4>
      </div>

      <div className="flex space-x-2 items-center w-full">
        {isLoading ? <Skeleton className="!w-4 !h-4 !rounded-full" /> : <div className="rounded-full bg-fg-sky-blue h-4 w-4"/>}
        <Paragraph className="text-fg-gray-dark flex-grow uppercase">{isLoading ? <Skeleton className="!w-12" /> : t('common:nutrient_carbs')}</Paragraph>
        <Heading4 className="text-left justify-self-end">{isLoading ? <Skeleton className="!w-10" /> : carbohydrate + t('common:nutrient_unit_gram')}</Heading4>
      </div>

      <div className="flex space-x-2 items-center w-full">
        {isLoading ? <Skeleton className="!w-4 !h-4 !rounded-full" /> : <div className="rounded-full bg-fg-indigo h-4 w-4"/>}
        <Paragraph className="text-fg-gray-dark flex-grow uppercase">{isLoading ? <Skeleton className="!w-8" /> : t('common:nutrient_fat')}</Paragraph>
        <Heading4 className="text-left justify-self-end">{isLoading ? <Skeleton className="!w-10" /> : fat + t('common:nutrient_unit_gram')}</Heading4>
      </div>
    </div>
  </div>
}